import React from "react";
import get from "lodash/get";
import { notificationsTemplates } from "../../utils/notification";
import { DEFAULT_BOARD_NAME } from "../../utils/constants";

const NotificationText = ({
  notification,
  viewProfile,
  viewTouchPoint,
  viewPage,
  setReviewed,
  t,
  onClick,
  columns,
  client,
}) => {
  const handleSecondaryLink = (e, action, url, notification) => {
    e.stopPropagation();
    setReviewed(notification, true);
    action(url);
    onClick();
  };

  let res = <span className="user-info">{t(`notifications.${notification.template}`)}</span>;
  let userLink, TPLink, pageLink;
  switch (notification.template) {
    case notificationsTemplates.TPCreated:
    case notificationsTemplates.firstTPCreated:
    case notificationsTemplates.TPCommentedOwner:
      userLink = notification.triggerUser;
      TPLink = get(notification, "effectedTouchPoint._id", "");
      res = (
        <span className="notification-info">
          {t(`notifications.${notification.template}Part1`, {
            lblTouchPoint: client?.lblTouchPoint,
            lblTouchPoints: client?.lblTouchPoints,
          }) && (
            <span className="notification-text">
              {t(`notifications.${notification.template}Part1`, {
                lblTouchPoint: client?.lblTouchPoint,
                lblTouchPoints: client?.lblTouchPoints,
              })}{" "}
            </span>
          )}
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewTouchPoint, TPLink, notification)}>
            {get(notification, "effectedTouchPoint.name", "")}
          </span>
          <span className="notification-text"> {t(`notifications.${notification.template}Part2`)} </span>
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewProfile, userLink, notification)}>
            {notification.triggerUser.name}
          </span>
          <span className="notification-text">{t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );
      break;
    case notificationsTemplates.TPLiked:
    case notificationsTemplates.milestoneCreated:
    case notificationsTemplates.TPEditedOwner:
    case notificationsTemplates.TPCommentedOther:
      userLink = notification.triggerUser;
      TPLink = get(notification, "effectedTouchPoint._id", "");
      res = (
        <span className="notification-info">
          {t(`notifications.${notification.template}Part1`) && (
            <span className="notification-text">{t(`notifications.${notification.template}Part1`)}</span>
          )}
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewProfile, userLink, notification)}>
            {notification.triggerUser.name}
          </span>
          <span className="notification-text">
            {" "}
            {t(`notifications.${notification.template}Part2`, { lblTouchPoint: client?.lblTouchPoint })}{" "}
          </span>
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewTouchPoint, TPLink, notification)}>
            {get(notification, "effectedTouchPoint.name", "")}
          </span>
          <span className="notification-text">{t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );
      break;
    case notificationsTemplates.surveyStarted:
      TPLink = get(notification, "effectedTouchPoint._id", "");
      res = (
        <span className="notification-info">
          {t(`notifications.${notification.template}Part1`, { lblTouchPoint: client?.lblTouchPoint }) && (
            <span className="notification-text">
              {t(`notifications.${notification.template}Part1`, { lblTouchPoint: client?.lblTouchPoint })}{" "}
            </span>
          )}
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewTouchPoint, TPLink, notification)}>
            {get(notification, "effectedTouchPoint.name", "")}
          </span>
          {""}
          <span className="notification-text">{t(`notifications.${notification.template}Part2`)}</span>
          <span className="notification-text">{t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );
      break;
    case notificationsTemplates.newCardCreated:
      const cardLink = `card/edit/${notification.card}`;
      const boardLink = "orga-board";
      res = (
        <span className="notification-info">
          {t(`notifications.${notification.template}Part1`) && (
            <span className="notification-text">{t(`notifications.${notification.template}Part1`)} </span>
          )}
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewPage, cardLink, notification)}>
            {t(`notifications.${notification.template}Link1`)}
          </span>
          <span className="notification-text"> {t(`notifications.${notification.template}Part2`)} </span>
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewPage, boardLink, notification)}>
            {(columns && columns.name) || DEFAULT_BOARD_NAME}
          </span>
          <span className="notification-text">{t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );
      break;
    case notificationsTemplates.userMentionedTP:
    case notificationsTemplates.userMentionedCard:
      const itemLink = notification.card
        ? `card/edit/${notification.card}`
        : `touchpoint/${get(notification, "effectedTouchPoint._id", "")}`;
      const itemTitle = notification.card
        ? t(`notifications.newCardCreatedLink1`)
        : get(notification, "effectedTouchPoint.name", "");
      res = (
        <span className="notification-info">
          {t(`notifications.${notification.template}Part1`) && (
            <span className="notification-text">{t(`notifications.${notification.template}Part1`)} </span>
          )}
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewPage, itemLink, notification)}>
            {itemTitle}
          </span>
          <span className="notification-text">{t(`notifications.${notification.template}Part2`)} </span>
          <span className="notification-text"> {t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );

      break;
    default:
      pageLink =
        notification.template === notificationsTemplates.ourBrandUpdated
          ? "our-brand"
          : notification.template === notificationsTemplates.surveyCreated
            ? "survey"
            : notification.template === notificationsTemplates.rankingLevel
              ? "profile"
              : notification.template === notificationsTemplates.quizCreated
                ? "quiz"
                : "tasks";
      res = (
        <span className="notification-info">
          <span className="notification-text">
            {t(`notifications.${notification.template}Part1`, { lblTouchPoint: client?.lblTouchPoint })}
          </span>
          <span className="secondary-link" onClick={e => handleSecondaryLink(e, viewPage, pageLink, notification)}>
            {t(`notifications.${notification.template}Part2`)}
          </span>
          <span className="notification-text">{t(`notifications.${notification.template}Part3`)}</span>
        </span>
      );
      break;
  }
  return res;
};

export default NotificationText;
